import * as Y from 'yjs';

export function isLocalYjsChange(
  doc: Y.Doc | null | undefined,
  transaction: Y.Transaction
): boolean {
  const origin = transaction.origin as
    | { proxy?: unknown }
    | number
    | Y.UndoManager
    | null
    | undefined;

  if (!doc || !origin || origin instanceof Y.UndoManager) {
    return true;
  }

  if (typeof origin === 'object' && origin.proxy) {
    return true;
  }

  return origin === doc.clientID;
}
